import i18n from '@/i18n';

export default {
	required: (value) =>
		(value !== null &&
			value !== undefined &&
			((typeof value === 'string' && value.trim() !== '') || typeof value !== 'string')) ||
		i18n.t('validations.required'),
	requiredArray: [val => (val || '').length > 0 || i18n.t('validations.required')],
	
	requiredAsNumber: val => (typeof val === 'number' && val > 0) || i18n.t('validations.required'),
	isString: (value) =>
		// eslint-disable-next-line no-misleading-character-class
		!value || /^[A-Za-z\u0621-\u064A\u064B-\u0652\W]+$/.test(value) || i18n.t('validations.isString'),
	isNumber: (value) => value === null || typeof value === 'number' || i18n.t('validations.isNumber'),
	isPercent: (value) => (value && value >= 0 && value <= 100)  || i18n.t('validations.isNumber'),
};
